import React from 'react';

import ErrorPage from '~/components/ErrorPage';
import { createTranslate } from '~/utils/translation';

import notFound from 'images/404.svg';


const tt = createTranslate('routes.invalid_link');


// A link that can't be used: a missing or unknown token, a payment return page opened
// outside its payment window... `action` is the way forward (see components/ErrorPage).
const InvalidLink = ({ action }) => (
  <ErrorPage
    modifier="invalidLink"
    titleAs="h1"
    image={notFound}
    title={tt('title')}
    subtitle={tt('subtitle')}
    action={action}
  />
);


export default InvalidLink;
